import {gql} from '@apollo/client';
import {PodRiskReviewAction, PodRiskReviewActionResult} from '../types/PodRiskReviewType';
import {PodRiskReviewFiltersTypeInput} from '../queries/getPodRiskReviewPageList';

/**
 * 提交舆情 POD 审核（一次一单，批量由前端逐条调用）
 * 审核员由后端取当前登录账号，前端不传 —— 防止伪造审核人。
 */
export const SUBMIT_POD_RISK_REVIEW_ACTION = gql`
    mutation SubmitPodRiskReviewAction(
        $reviewTaskId: String!
        $action: PodRiskReviewActionType!
        $riskTypeCodes: [String!]
        $reviewRemark: String
        $reviewRemarkLang: String
    ) {
        submitPodRiskReviewAction(
            reviewTaskId: $reviewTaskId
            action: $action
            riskTypeCodes: $riskTypeCodes
            reviewRemark: $reviewRemark
            reviewRemarkLang: $reviewRemarkLang
        ) {
            reviewTaskId
            orderId
            trackingNumber
            status
            reviewerId
            reviewedAt
        }
    }
`;

export interface SubmitPodRiskReviewActionResponse {
    submitPodRiskReviewAction: PodRiskReviewActionResult;
}

export interface SubmitPodRiskReviewActionInput {
    reviewTaskId: string;
    action: PodRiskReviewAction;
    /** 判定「存在舆情风险」时必填 */
    riskTypeCodes?: string[];
    reviewRemark?: string;
    /** 备注原文语种（前端当前 locale）；后端据此填充富化 JSON 的 lang */
    reviewRemarkLang?: string;
}

/**
 * 导出当前筛选结果（不分页，两个 Tab 都可导出）
 * 文件由服务端异步生成，success 仅表示任务已受理，需到下载中心取文件。
 */
export const DOWNLOAD_POD_RISK_REVIEW = gql`
    mutation DownloadPodRiskReview(
        $filters: PodRiskReviewFiltersTypeInput
        $language: String
        $timezone: String
    ) {
        downloadPodRiskReview(filters: $filters, language: $language, timezone: $timezone) {
            success
            errorCode
            fileName
        }
    }
`;

export interface DownloadPodRiskReviewResponse {
    downloadPodRiskReview: {
        success: boolean;
        /** NO_DATA / EXCEED_MAX_LIMIT:{上限}；成功时为 null */
        errorCode?: string;
        fileName?: string;
    };
}

export interface DownloadPodRiskReviewInput {
    filters?: PodRiskReviewFiltersTypeInput;
    /** zh / en / es */
    language?: string;
    /** IANA 时区，如 Asia/Shanghai */
    timezone?: string;
}
